const changePreferencesToggles = document.querySelectorAll('.js-change-preferences');

function togglePreferences(e) {
  e.preventDefault();

  const body = document.body;
  body.classList.add('disable-scroll-mobile');

  const cookieBar = document.querySelector('.js-cookie-bar');
  cookieBar.classList.add('show-preferences');
}

if (changePreferencesToggles.length > 0) {
  changePreferencesToggles.forEach((toggle) => toggle.addEventListener('click', togglePreferences));
}
